module.exports = __webpack_public_path__ + "static/media/武汉车都大厦-min.5fb5e8ba.jpg";